import { cn } from '@/lib/utils';

/** Selo de tom (pill azul escuro, texto `accent-soft`). */
export const KeyBadge: React.FC<{ value: string; className?: string }> = ({
  value,
  className,
}) => (
  <span
    className={cn(
      'inline-flex h-6 min-w-8 shrink-0 items-center justify-center rounded-full bg-accent-surface px-2.5 font-bold text-[12px] text-accent-soft ring-1 ring-accent-line',
      className,
    )}
  >
    {value}
  </span>
);
